let elements = {
	"backgrounds": [
		"landscape",
		"night"
	],
	"titles": [
		{
			"id": "#home",
			"page": "/home",
			"name": "Accueil"
		},
		{
			"name": "Qui suis-je ?"
		},
		{
			"id": "#resume",
			"page": "/resume",
			"name": "Formations"
		}, 
		{
			"name": "Expériences"
		},
		{
			"id": "#skills",
			"page": "/skills",
			"name": "Compétences"
		},
		{
			"id": "#languages",
			"page": "/languages",
			"name": "Langages"
		},
		{
			"id": "#projects",
			"page": "/projects",
			"name": "Projets"
		},
		{
			"id": "#awards",
			"page": "/awards",
			"name": "Récompenses",
		},
		{
			"id": "#contact",
			"page": "/contact",
			"name": "Contact"
		}
	]
  }
  
export default elements;
